import styled from 'styled-components/macro';

export const LogoWrapper = styled.div`
  text-align: center;
`;
